import { createAsyncThunk } from '@reduxjs/toolkit';
import { creativeUploadService } from '../../services';

const getCreatives = createAsyncThunk(
    'creativeUpload/getCreatives',
    async (payload, thunkAPI) => {
        try {
            const response = await creativeUploadService.getCreative(
                payload.companyId
            );
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    }
);

const getCreativeById = createAsyncThunk(
    'creativeUpload/getCreativeById',
    async (payload, thunkAPI) => {
        try {
            const response = await creativeUploadService.getCreativeById(
                payload.Id
            );
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    }
);

const postCreativeUpload = createAsyncThunk(
    'creativeUpload/postCreativeUpload',
    async (payload, thunkAPI) => {
        try {
            const response = await creativeUploadService.postCreativeUpload(
                payload.data
            );
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    }
);

const deleteCreative = createAsyncThunk(
    'creativeUpload/deleteCreative',
    async (payload, thunkAPI) => {
        try {
            const response = await creativeUploadService.deleteCreative(
                payload.companyId,
                payload.data
            );
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    }
);

const editCreativeUpload = createAsyncThunk(
    'creativeUpload/editCreativeUpload',
    async (payload, thunkAPI) => {
        try {
            const response = await creativeUploadService.editCreative(
                payload.data,
                payload.id
            );
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    }
);

export { 
    getCreatives,
    postCreativeUpload,
    deleteCreative,
    getCreativeById,
    editCreativeUpload
};